import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, memo } from 'react';
import { encodeStringToBase64 } from 'Common/utils';
import useRouter, { PhenotypeViewRoute, } from 'Router/index';
import TableCellLink from '../TableCellLink/TableCellLink';
export const PhenotypeTableCellLink = memo(function PhenotypeTableCellLink({ label, phenotypeId, levelResult, referrerData, datasetVersionIdFromAPI, }) {
    const { getParams, getLocation } = useRouter();
    const { pathname } = getLocation();
    const { encodedPhenotypeName, datasetVersionId: datasetVersionIdFromParams, } = getParams();
    const datasetVersionId = datasetVersionIdFromAPI || datasetVersionIdFromParams;
    const path = PhenotypeViewRoute.getPath({
        phenotypeId,
        encodedPhenotypeName: encodedPhenotypeName
            || encodeStringToBase64((referrerData === null || referrerData === void 0 ? void 0 : referrerData.phenotypeName) || ''),
        datasetVersionId,
        levelResult,
    });
    const route = useMemo(() => ({
        pathname: path,
        state: {
            referrerURI: pathname,
            referrerData,
        },
    }), [path, pathname, referrerData]);
    return (_jsx(TableCellLink, { route: route, label: label, title: label }, void 0));
});
